const getters = {
  sidebar: (state) => state.app.sidebar, // 侧边栏
  menus: (state) => state.user.menus, // 用户当前权限的菜单
  adminType: (state) => state.user.type, // 用户当前身份
  addRouters: (state) => state.permission.addRouters, // 根据权限添加路由
  permissionRouters: (state) => state.permission.routers, // 去权限的全部路由
  themeColor: (state) => state.settings.theme, // 主题色
  successColor: (state) => state.settings.success
}

export default getters
